
import React, { useEffect, useState, useRef } from "react";
import { MemoryRouter as Router, useNavigate, Route, Routes, useLocation, Navigate, useParams } from 'react-router-dom'; // HashRouter, MemoryRouter or BrowserRouter? 
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { I18nextProvider, Trans } from "react-i18next";
import i18n from "../../Documental/Localization/i18n.js";
import StateMachine from 'react-simple-state/dist';
import LanguageChoosePage from  '../LanguageChoosePage/LanguageChoosePage';
import BookingPage from  '../BookingPage/BookingPage';
import LandingPage from  '../LandingPage/LandingPage';
import RepeatVisitLandingPage from  '../LandingPage/RepeatVisitLandingPage.js';
import RatePage from  '../RatePage/RatePage';
import FinishedPage from  '../FinishedPage/FinishedPage';
import FinishedPageNotRefugee from  '../FinishedPageNotRefugee/FinishedPageNotRefugee';

import TopNav from  './TopNav';

// import BookingStartForm from  '../BookingStartForm/BookingStartForm';
import QuestionnaireContainer from  '../Questionnaire/QuestionnaireContainer';
import Results from  '../Questionnaire/Results';
import BrandBackground from './BrandBackground';
import BrandBackgroundSimple from './BrandBackgroundSimple';
import SessionCookie from './../../Documental/Utils/SessionCookie.js';

const appState = new StateMachine();

var userLoggedDone = false;
var userLoggedMessage = false;
window.askConfirmationBeforeLeaving = false;

const AnimatedPageSwitch = ( props ) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [transitionName, setTransitionName] = useState("trans-fade");
  // const [transitionName, setTransitionName] = useState("trans-slide-next");
  
  /**
   * Redirect user back to start if auth status changes (user logged out)
   * 
   * @param object newAppAuthStatus 
   */
  const handleAuthStatus = function( newAppAuthStatus ){
    if( !newAppAuthStatus.isAuthenticated() ){
      userLoggedMessage = false;
      userLoggedDone = true;

      // reset user logged in related values

      if(
        location.pathname.indexOf( "/start" ) < 0 &&  
        location.pathname.indexOf( "/language" ) < 0 
      ){
        navigate( '/' );
      }
    } else {
      // user logged in state set
      userLoggedMessage = true;
      userLoggedDone = true;
    }
  }

  useEffect(() => {
    appState.subscribe( 'app-auth-status', "functionalPatientApp", handleAuthStatus );

    return function cleanup() {
      appState.unsubscribe( 'app-auth-status', "functionalPatientApp" );
    };
  });

  useEffect(() => {
  //  if (transitionName === "next") setTransitionName("prev");
  //  if (transitionName === "prev") setTransitionName("next");
  }, [location]);
  

  let bgWithLogo = false;
  if( location.pathname === "/" || location.pathname === "/language" ){
    bgWithLogo = true;
  }

  // Add page leave protection on some of the pages
  if( 
    location.pathname === "/" || 
    location.pathname === "/language" || 
    location.pathname.indexOf("/start") > -1 || 
    location.pathname.indexOf("finished") > -1
  ){
    window.askConfirmationBeforeLeaving = false;
  } else {
    window.askConfirmationBeforeLeaving = true;
  }

  // Change language if defined by route
  let lang = '';
  let test = location.pathname.substring( 0, 4 );

  if( typeof i18n.services !== 'undefined' && typeof i18n.services.resourceStore !== 'undefined' ){
    let languages = Object.keys( i18n.services.resourceStore.data );
    for( var i1 in languages ){
      let langCode = languages[ i1 ];
      if( test.indexOf( langCode + "/" ) > -1  ){
        lang = langCode;
      }
      if( location.pathname === "/" + langCode + "/start" ){
        bgWithLogo = true;
      }
      if( location.pathname === "/" + langCode + "/repeat-visit" ){
        bgWithLogo = true;
      }
      if( location.pathname === "/" + langCode + "/finished" ){
        // bgWithLogo = true;
      }
    }
  }
  
  if( lang && lang !== i18n.language ){
    i18n.changeLanguage( lang );
  }
  

  // Is session actually started? Wait server for first message via websocket
  let sessionStillLoading = false;
  if( !userLoggedMessage || !window.apiClient.isFirstMessageReceived() ){
    sessionStillLoading = true;
  }

  // wait until app main mode is loaded
  let mainMode = appState.getState( 'app-main-mode' );
  if( !mainMode.appMainModeLoaded ){
    console.log( "Waiting for app mode to be set" );
    sessionStillLoading = true;
  }

  // in case of app mode "app-main-mode-repeat-visit"- wait also patient resource to be loaded to get preferred language
  let patientEntity = null;
  if( mainMode.appMainMode === "app-main-mode-repeat-visit" ){
    if( 
      location.pathname === "/" || 
      location.pathname === "/language" || 
      location.pathname === ""
    ){
      let patients = window.appEntityStore.getAllResourcesBySearchParams({
        "resourceType" : "Patient"
      });
      for( var i2 in patients ){
        patientEntity = patients[ i2 ];// Only 1 patient should be in session
      }
      if( patientEntity === null ){
        sessionStillLoading = true;
      } else {
        let languageCode = patientEntity.getFirstCommunicationLanguageCode();
        if( languageCode === "" || languageCode === null){
          languageCode = "en";
        }
        navigate( '/' + languageCode + '/repeat-visit' );
      }
    }
  }


  // based on: 
  // https://codesandbox.io/s/lqc45?file=/src/App.js
  return (
    <TransitionGroup className="main-page" >
      <CSSTransition
        key={location.pathname}
        classNames={transitionName}
        timeout={221}
      >
        <Routes location={location}>
          <Route exact path="/language" element={<LanguageChoosePage sessionStillLoading={sessionStillLoading} />} />
          <Route exact path=":lang/start" element={<LandingPage/>}/>
          <Route exact path=":lang/repeat-visit" element={<RepeatVisitLandingPage/>}/>

          <Route exact path=":lang/questionnaire" questionnaireId="self-report-v1" element={<QuestionnaireContainer/>} />
          <Route exact path=":lang/questionnaire/:id" element={<QuestionnaireContainer/>} />
          <Route exact path=":lang/questionnaire/results/:id" element={<Results />} />
          <Route exact path=":lang/booking" element={<BookingPage />} />
          <Route exact path=":lang/rate" element={<RatePage />} />
          <Route exact path=":lang/finished" element={<FinishedPage />} />
          <Route exact path=":lang/finished/ref" element={<FinishedPageNotRefugee />} />
          
          <Route exact path="/" element={<Navigate replace to="/language" />} />
        </Routes>
      </CSSTransition>
      <BrandBackgroundSimple withLogoBg={bgWithLogo} />
    </TransitionGroup>
  );
};


class PatientApp extends React.Component {

  constructor( props ) {
    super( props );
    
    this._isMounted = false;
    this.reConnectTimer = null;

    this.state = {
      "forceRenderCnt" : 0,
      "debugCounter" : 1,
      "isAppHalted" : false,
      "appAuthStatus" : appState.getState( 'app-auth-status' )

    }
    
    window.debugNumber2 = Math.round( Math.random() * 100 );

    this.anonymousLoginRequested = false;
    this.tokenLoginRequested = false;
    this.handleLogout = this.handleLogout.bind( this );
    this.handleDebugClick = this.handleDebugClick.bind( this );
    this.handleResetWebsocketClick = this.handleResetWebsocketClick.bind( this );
    this.debugTimer = this.debugTimer.bind( this );
  }

  
  componentDidMount() {
    this._isMounted = true;
    var that = this;

    var updateView = function (eventPayLoad) {
      if (that._isMounted) {
        that.updateView();
      }
    };

    appState.subscribe( 'app-auth-status', this, ( newAppAuthStatus ) => {
      let next = ( that.state.forceRenderCnt + 1 );
      
      if( process.env.REACT_APP_CONFIG_ENV === "development" ){
        console.log( "App auth status changed in component: " );
        console.log( newAppAuthStatus );
      }

      if( !newAppAuthStatus.isAuthenticated() ){
        that.anonymousLoginRequested = false;
      }
      that.setState({
        "appAuthStatus": newAppAuthStatus,
        "forceRenderCnt": next
      });
      setTimeout(function () {
        that.anonymousLoginRequested = false;
        that.tokenLoginRequested = false;
        that.checkLoginStatusPoll();
      }, 100 );
    });
    

    appState.subscribe( 'connection-state', this, ( newStatus ) => {
      that.checkConnection( newStatus );
    });
    
    window.appEventsEmitter.addListener("ServerCommunicationHandeled", updateView );
    this.listenerUpdateView = updateView;
    
    this.timerCheckAuthStatus = null;
    this.anonymousLoginRequested = false;
    this.tokenLoginRequested = false;
    this.checkLoginStatusPoll();

    this.setupPageNavigateAwayProtection();
    

    this.debugTimer();
  }


  componentWillUnmount() {
    this._isMounted = false;
    appState.unsubscribe( 'app-auth-status', this );
    appState.unsubscribe( 'connection-state', this );

    window.appEventsEmitter.removeListener(
      "ServerCommunicationHandeled",
      this.listenerUpdateView
    );

    if ( this.timerCheckAuthStatus != null) {
      clearTimeout( this.timerCheckAuthStatus );
    }

    this.disablePageNavigateAwayProtection();
  }


  debugTimer(){
    var that = this;

    //if ( this.timerDebugCounter != null) {
    //  clearTimeout( this.timerCheckAuthStatus );
    //}

    this.setState({
      "debugCounter" : ( this.state.debugCounter + 1 )
    });

    setTimeout(function () {
      that.debugTimer();
    }, 1000 );
  }

  /**
   * 
   * Before leaving app page- ask user about leaving
   * 
   * This is used by chrome version 106.xx
   * Message can't be changed since Chrome 51. It is widely considered a security issue, and most vendors have removed support.
   * 
   */
  setupPageNavigateAwayProtection(){
    
    var beforeListener = function ( event ) {
      if( window.askConfirmationBeforeLeaving ){
        event.preventDefault();
        event.returnValue = "Are you sure you want to exit app?"; // It's not actually used, but needed to trigger the dialog
        return event;
      }
    }

    window.addEventListener( "beforeunload", beforeListener );
    this.beForeListener = beforeListener;
  }

  
  disablePageNavigateAwayProtection(){
    window.removeEventListener( "beforeunload", this.beForeListener );
  }
  

  /**
   * Render error screen when websocket is dropped after intial connection
   * 
   * 
   */
  checkConnection( newStatus ){
    let next = ( this.state.forceRenderCnt + 1 );

    if( !newStatus.connected ){
      if( typeof newStatus.wsStoppedConnecting !== "undefined" && newStatus.wsStoppedConnecting ){
        this.setState( {
          isAppHalted : true,
          forceRenderCnt: next
        });
      }

      this.anonymousLoginRequested = false;
      this.tokenLoginRequested = false;
      this.checkLoginStatusPoll();
    }

  }


  /**
   * If there is no logged in user (or anonymous user) 
   * wait until we have logged in 
   * 
   * 
   */
   checkLoginStatusPoll(){
    var that = this;

    if( process.env.REACT_APP_CONFIG_ENV === "development" ){
      //console.log("POLLING checkLoginStatusPoll (" + window.apiClient.firstMessageTokenOrCredentials + "), T:" +  window.apiClient.lastTokenOrCredentials + " / A:" + this.anonymousLoginRequested + " / FM:" + window.apiClient.isFirstMessageReceived() );
    }
    
    if ( this.timerCheckAuthStatus != null) {
      clearTimeout( this.timerCheckAuthStatus );
    }

    let pollMore = false;

    // wait first message before procceeding
    if( !window.apiClient.isFirstMessageReceived() ){
      pollMore = true;
    }
    
    if( pollMore ){
      this.timerCheckAuthStatus = setTimeout(function () {
        that.checkLoginStatusPoll();
      }, 200 );
      return;
    }

    var sessionCookie = new SessionCookie();
    const token = sessionCookie.readCookieValue("app-auth-token");

    if( window.apiClient.lastTokenOrCredentials === "NEEDS_TOKEN" && token ){
      //if( !this.tokenLoginRequested ){
        this.tokenLoginRequested = true;
        var tokenBundle =
        {
          "resourceType": "Bundle",
          "type": "batch",
          "entry": [
            {
              "resource": {
                "resourceType": "Person",
                "identifier": [
                  {
                    "system": "https://documental.abtram.eu/fhir/namingsystem/session/token",
                    "value": token
                  }
                ],
                "managingOrganization": {
                  "reference": "Organization/haigla"
                }
              },
              "request": {
                "method": "POST",
                "url": "Person"
              }
            }
          ]
        }
    
        window.apiClient.sendBundle( tokenBundle );
        window.apiClient.lastTokenOrCredentials = "";
      //}
    } else if( window.apiClient.firstMessageTokenOrCredentials === "NEEDS_CREDENTIALS" ) {
      if( !this.anonymousLoginRequested ){
        let requested = this.sendAnonymousLoginRequest();
        if( requested ){
          this.anonymousLoginRequested = true;
        }
      }
    }

    /** actually no need to stop polling ... 
     *  One reason could be that if user initially is logged in, but leaves. Server 
     * could eventually end session. App must reset itself when that happens. 
     * 
    if( 
      this.state.appAuthStatus.isAuthenticated() && 
      window.apiClient.isFirstMessageReceived() && 
      (
        window.apiClient.firstMessageTokenOrCredentials === ""
      )
    ){
      console.log( "User is authenticated" );
      return;
    }
     */

    this.timerCheckAuthStatus = setTimeout(function () {
      that.checkLoginStatusPoll();
    }, 500 );
  }


  handleLogout(){
    window.appEventsEmitter.emit( 'deauthenticated' );
  }


  handleDebugClick(){
  }


  sendAnonymousLoginRequest(){

    if( !window.apiClient.isFirstMessageReceived() ){
      return false;
    }

    // TOKEN or anonymous login strategy
    // window.apiClient.firstMessageTokenOrCredentials

    let anonymousLoginBundle = {
      "resourceType": "Bundle",
      "type": "batch",
      "entry": [{
              "resource": {
                  "resourceType": "Person",
                  "meta": {
                      "profile": ["http://documental.ee/fhir/profile/person/anonymous"]
                  },
                  "managingOrganization": {
                      "reference": "Organization/haigla"
                  }
              },
              "request": {
                  "method": "POST",
                  "url": "Person"
              }
          }
      ]
    }

    let sent = window.apiClient.sendBundle( anonymousLoginBundle );

    if( sent ){
    }

    return sent;
  }

  
  updateView(){
    let next = ( this.state.forceRenderCnt + 1 );
    this.setState({
      "forceRenderCnt": next
    });
  }


  /**
   * 
   * @return PractitionerRole|null
   */
  getCurrentlyLoggedInPracticionerRole(){
    if( typeof window.appLoggedInUser === 'undefined' || !window.appLoggedInUser.isLoggedIn ){
      return null;
    }

    return window.appEntityStore.getEntityByEntityId( window.appLoggedInUser.practitionerRoleId );
  }


  handleResetWebsocketClick(){
    if(this.reConnectTimer ){
      clearTimeout( this.reConnectTimer );
    }

    this.reConnectTimer = setTimeout(function () {
      window.apiClient.resetConnection();
    }, 100 );
  }


  render(){
    var that = this;

    let isLoggedIn = this.state.appAuthStatus.isAuthenticated();

    let haltedText1 = i18n.t( "Internet connection lost. " );
    let haltedText2 = i18n.t( "Please start over. " );
    
    if( this.state.isAppHalted ){
      return (
        <div className="App app-container">
          <div className="main-page" >
            <div className="app-page app-page-halted">
              <TopNav showLanguageLinks={false} />
              <br />
              {haltedText1}
              <br />
              {haltedText2}
            </div>
            
            <BrandBackgroundSimple withLogoBg={true} />
          </div>
        </div>
      );
    }

    let showDebug = false;
    if( process.env.REACT_APP_CONFIG_ENV === "development" ){
      if( window.location.href.indexOf( 'app.documental.ee' ) > -1 ){
        showDebug = true;
      }
    }
    
    // {( this.state.redirectTo ) && (
    //   <Navigate to="/dashboard" />
    // )}

    // If using hash or browser router - add  basename={process.env.PUBLIC_URL} to Router

    return (
      <I18nextProvider i18n={i18n}>
        <Router initialEntries={["/"]}>
          <div className="App app-container" >

            {( showDebug) && (
            <div style={{"position": "fixed", "padding":"0.5rem", "background" : "rgba(100, 100, 100, 0.7)", "color" : "white", "zIndex" : "9999999999", "textAlign": "right", "border": "1px solid green", "top" : "1.5rem", "right" : "0.5rem" }}>
              websocket open cnt: {window.apiClient.connectedCounter} <br />
              Need creds cnt: {window.apiClient.needsCredsCounter} <br />
              Need token cnt: {window.apiClient.needsTokenCounter} <br />
              Entitystore clear all cnt: {window.appEntityStore.clearAllCalledCount} <br />
              WS reset cnt: {window.apiClient.resetCalledCounter}<br />
              debugtimer: {this.state.debugCounter}
              <br />
              <button  onClick={ ( e ) => that.handleResetWebsocketClick( e ) } >Reset WS</button>
              <br />
            </div>
            )}
            
            {( isLoggedIn || !isLoggedIn ) && (
              <AnimatedPageSwitch />
            )}

            {/* ( !isLoggedIn ) && (
              <Link to="login">Login</Link>
              <Link to="dashboard">Dash</Link>

              <div maxWidth={false} className="content-container mdl-layout__container app-main-container">
                <div className="mdl-grid padding-0 home-bg">
                  <LoginClientForm />
                </div>
              </div>
            )}

            {( isLoggedIn ) && (
              <div maxWidth="lg" className="content-container">
                <br />
                <br />
                <h1>Hello dm</h1>
              </div>
            )*/}

          </div>
        </Router>
      </I18nextProvider>
    );
  }
}

export default PatientApp;
